import { FormGroup, Input } from "../../../../@coherent/react-hook-form";
import { isEmail } from "validator";
import React from "react";

export const ReferralForm = ({ disabled = false }) => {
  return (
    <fieldset disabled={disabled}>
      <FormGroup required name="first_name" label="First Name of the Applicant">
        <Input
          defaultValue=""
          name="first_name"
          className="form-control"
          rules={{
            required: true,
          }}
        />
      </FormGroup>
      <FormGroup required name="last_name" label="Last Name of the Applicant">
        <Input
          defaultValue=""
          name="last_name"
          className="form-control"
          rules={{
            required: true,
          }}
        />
      </FormGroup>
      <FormGroup required name="email" label="Email Address of the Applicant">
        <Input
          defaultValue=""
          type="email"
          name="email"
          className="form-control"
          rules={{
            required: true,
            validate: isEmail,
          }}
        />
      </FormGroup>
    </fieldset>
  );
};
